// channel capabilities
export const AI_SUMMARY = 'AI_SUMMARY';
export const AT_MENTIONS = 'AT_MENTIONS';
export const ATTACHMENTS = 'ATTACHMENTS';
export const IMAGES = 'IMAGES';
export const FORMATTED_HYPERLINKS = 'FORMATTED_HYPERLINKS';
export const RICH_TEXT = 'RICH_TEXT';
export const PLAIN_TEXT = 'PLAIN_TEXT';
// editing capabilities
export const AI_ASSISTANT = 'AI_ASSISTANT';
export const CONTENT_ASSISTANT = 'CONTENT_ASSISTANT';
export const INSERT_CORE = 'INSERT_CORE';
export const INSERT_TEMPLATES = 'INSERT_TEMPLATES';
export const INVOICES = 'INVOICES';
export const PAYMENT_LINKS = 'PAYMENT_LINKS';
export const SUBMIT_ON_ENTER = 'SUBMIT_ON_ENTER';
export const MODEL_SMART_COMPOSE = 'MODEL_SMART_COMPOSE';
export const USER_DEFAULT_FONT = 'USER_DEFAULT_FONT';
export const CONTENT_ASSISTANT_SLASH_COMMAND = 'CONTENT_ASSISTANT_SLASH_COMMAND';
export const CONTENT_ASSISTANT_INLINE_MENU = 'CONTENT_ASSISTANT_INLINE_MENU';
// inline styles
export const BOLD = 'BOLD';
export const ITALIC = 'ITALIC';